import React from 'react';

interface InfoCardGridProps {
    children: React.ReactNode;
    className?: string;
}

export const InfoCardGrid: React.FC<InfoCardGridProps> = ({
    children,
    className = ''
}) => {
    return (
        <div className={`flex w-full max-w-layout-info-grid gap-5 flex-col md:flex-row ${className}`}>
            {children}
        </div>
    );
};

export default InfoCardGrid;
